import React from 'react';
import './DateTimeInput.css';

// Convert Date object to "HH:mm" string for <input type="time">
const toInputValue = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) return '';
    const h = String(date.getHours()).padStart(2, '0');
    const m = String(date.getMinutes()).padStart(2, '0');
    return `${h}:${m}`;
};

const TimePickerInput = ({
    selected,
    onChange,
    isInvalid = false,
    placeholder = 'Select time',
}) => {
    const handleChange = (e) => {
        const val = e.target.value;
        if (!val) {
            onChange(null);
            return;
        }
        const [h, m] = val.split(':').map(Number);
        const date = new Date();
        date.setHours(h, m, 0, 0);
        onChange(date);
    };

    return (
        <input
            type="time"
            value={toInputValue(selected)}
            onChange={handleChange}
            placeholder={placeholder}
            className={`project-form-input ${isInvalid ? 'error' : ''}`}
        />
    );
};

export default TimePickerInput;
